/*
Sohel 03/23/2023 2699762545 Added Organization Search Table
Akhila 05/24/2024 2699762545 role access implemeneted
Ravi 05/31/2023 2699762545 changed delete popup message
*/
import React, {useState} from 'react';
import {Tooltip, IconButton} from '@material-ui/core';
import {DeleteOutlined, Edit} from '@material-ui/icons';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import {withField} from '../../../FrameWorks/DataManager/DataManagerRecord/AddDataManagerRecord/RecordFormatFieldsComponents/withField';

function GroupRecord(props) {
  const {
    value,
    index,
    values,
    key,
    dmArrayHelpers,
    setIsEdit,
    setRowData,
    deletedIds,
    setDeletedIds,
    LetterMainAccess,
    editExisting,
  } = props;
  const [isDelete, setIsDelete] = useState(false);
  const handleClose = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () => {
    dmArrayHelpers?.current?.remove(index);
    if (values?.organizationFields[index]?.letterClientId) {
      const ids = [...deletedIds, values?.organizationFields[index]?.letterClientId];
      setDeletedIds(ids);
    }
    setIsDelete(false);
  };

  return (
    <>
      <tr key={key}>
        <td className="recFormat-col recFormat-center">
          <Tooltip title="Edit">
            <IconButton
              disabled={editExisting && !LetterMainAccess?.edit}
              onClick={() => {
                setIsEdit(true);
                const row = {...value, index};
                setRowData(row);
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              onClick={() => setIsDelete(true)}
              disabled={editExisting && !LetterMainAccess?.edit}
            >
              <DeleteOutlined />
            </IconButton>
          </Tooltip>
        </td>
        <td className="recFormat-col global-field-textfields">{value.organizationType}</td>
        <td className="recFormat-col global-field-textfields">{value.organizationCode}</td>
      </tr>

      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Organization Type"
        value={`Are you sure you want to delete the ${value.organizationCode} Organization Type?`}
        handleSubmit={handleConfirmDelete}
      />
    </>
  );
}
export default withField(GroupRecord);
